import React, { useState, useEffect } from 'react'

import { config } from '../../config/index'
import CancelledShift from './CancelledShift'
// import CommunicationNew from './CommunicationNew'
// import CommunicationUpdated from './CommunicationUpdated'
// import EDocsUpdate from './EDocsUpdate'
// import EventsUpdate from './EventsUpdate'
// import RewardsUpdate from './RewardsUpdate'
import ScheduleReleasedAdditional from './ScheduleReleasedAdditional'
import ScheduleReleasedRequired from './ScheduleReleasedRequired'
import ShiftAbsent from './ShiftAbsent'
import ShiftExtension from './ShiftExtension'
import ShiftPulse from './ShiftPulse'
import ShiftReminder24 from './ShiftReminder24'
import ShiftReminder130 from './ShiftReminder130'
import ShiftReminder2 from './ShiftReminder2'
import ShiftReplacementRequest from './ShiftReplacementRequest'
import ShiftReplacementFailed from './ShiftReplacementFailed'
import ShiftReplacementSuccess from './ShiftReplacementSuccess'
import ShiftVTO from './ShiftVTO'
import VTOShiftsReleased from './VTOShiftsReleased'
import WeeklyShiftAssigned from './WeeklyShiftAssigned'
import PreferredShifts from './PreferredShifts'
import ShiftReminder from './ShiftReminder'
import ToastUtil from "../../components/ToastNotification/ToastUtil";
const { API_URL } = config

const NotificationsDetail = ({ match: { params } }) => {
    const token           = localStorage.getItem('token')
    const notification_id = params.id
    const user            = JSON.parse(localStorage.getItem('user'))

    const [notification, setNotification] = useState(null)
    const [schedule, setSchedule] = useState(null)

    useEffect(() => {
        const fetchNotification = async () => {
            let url = `${API_URL}/associate/notification/${notification_id}`

            try {
                let response = await fetch(url, {
                    mode: "cors",
                    method: "GET",
                    withCredentials: true,
                    headers: {
                      Authorization: token,
                      "Access-Control-Allow-Origin": "*",
                      "Content-Type": "application/json charset=utf-8"
                    }
                })
  
                let data = await response.json()

                if (response.ok) {
                    setNotification(data.data)
                } else {
                    ToastUtil.error(response.message)
                }
            } catch (error) {
                console.log(error)
            }
        }

        fetchNotification()
    }, [token, notification_id])

    useEffect(() => {
        const fetchSchedule = async () => {
            if (notification) {
                let schedule_id = notification.schedule_id ? notification.schedule_id : null

                if (schedule_id) {
                    let url = `${API_URL}/schedule/${schedule_id}`

                    try {
                        let response = await fetch(url, {
                            mode: "cors",
                            method: "GET",
                            withCredentials: true,
                            headers: {
                              Authorization: token,
                              "Access-Control-Allow-Origin": "*",
                              "Content-Type": "application/json charset=utf-8"
                            }
                        })
        
                        let data = await response.json()

                        if (data.success) {
                            setSchedule(data.data)
                        } else {
                            ToastUtil.error(data.message)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
            }
        }

        fetchSchedule()
    }, [token, notification])

    useEffect(() => {
        if (notification) {
            const isRead = async () => {
                let url = `${API_URL}/notification/associate/${user.id}/read`

                try {
                    await fetch(url, {
                        mode: "cors",
                        method: "PUT",
                        body: JSON.stringify({ notifications: [notification_id] }),
                        withCredentials: true,
                        headers: {
                          Authorization: token,
                          "Access-Control-Allow-Origin": "*",
                          "Content-Type": "application/json; charset=utf-8"
                        }
                    })
                } catch (error) {
                    console.log(error)
                }
            }

            isRead()
        }
    }, [notification])

    return (
        <React.Fragment>
            {
                notification && (
                    notification.type === 1
                        ? <WeeklyShiftAssigned notification={notification} schedule={schedule} />
                        : notification.type === 2
                        ? <ScheduleReleasedAdditional notification={notification} schedule={schedule} />
                        : notification.type === 3
                        ? <ShiftReplacementRequest notification={notification} schedule={schedule} />
                        : notification.type === 4
                        ? <ShiftReplacementRequest notification={notification} schedule={schedule} />
                        : notification.type === 5
                        ? <ShiftReplacementSuccess notification={notification} schedule={schedule} />
                        : notification.type === 6
                        ? <ShiftReplacementFailed notification={notification} schedule={schedule} />
                        : notification.type === 7
                        ? <VTOShiftsReleased notification={notification} schedule={schedule} />
                        : notification.type === 8
                        ? <ShiftExtension notification={notification} schedule={schedule} />
                        : notification.type === 9
                        ? <ShiftAbsent notification={notification} schedule={schedule} />
                        : notification.type === 10
                        ? <ShiftReminder24 notification={notification} schedule={schedule} />
                        : notification.type === 11
                        ? <ShiftReminder130 notification={notification} schedule={schedule} />
                        : notification.type === 26
                        ? <ShiftReminder2 notification={notification} schedule={schedule} />
                        : notification.type === 12
                        ? <CancelledShift notification={notification} schedule={schedule} />
                        : notification.type === 13
                        ? <PreferredShifts notification={notification} schedule={schedule} />
                        : notification.type === 14
                        ? <ShiftVTO notification={notification} schedule={schedule} />
                        : notification.type === 33
                        ? <ShiftReminder notification={notification} schedule={schedule} />
                        : ''
                )
            }
        </React.Fragment>
    )
}

export default NotificationsDetail
